window.initializeTooltip = (tooltipElement) => {
    document.addEventListener('mousemove', (e) => {
        const tooltip = tooltipElement;
        if (!tooltip) return;
        const tooltipWidth = tooltip.offsetWidth;
        const tooltipHeight = tooltip.offsetHeight;
        tooltip.style.left = `${e.clientX + window.scrollX - (tooltipWidth / 2)}px`;
        tooltip.style.top = `${e.clientY + window.scrollY - 5 - (tooltipHeight)}px`;
    });
};
